import Drawer from 'Components/Drawer';
import PropTypes from 'prop-types';
import React from 'react';

const Component = props => {
    const { big, context, editComponent: EditComponent, newComponent: NewComponent, showComponent: ShowComponent } = props;
    const { onClose } = props;

    // The entity is global state and outlives a navigation: a page that has no component for
    // what is open simply has no drawer.
    const Content = { edit: EditComponent, new: NewComponent, show: ShowComponent }[context];
    if (!Content) {
        return null;
    }

    return (
        <Drawer big={big} onClose={onClose}>
            <Content onClose={onClose}/>
        </Drawer>
    );
};

Component.propTypes = {
    context: PropTypes.string,
    showComponent: PropTypes.elementType,
    newComponent: PropTypes.elementType,
    editComponent: PropTypes.elementType,
    onClose: PropTypes.func.isRequired
};

export default Component;
